module.exports = __webpack_public_path__ + "img/siglewhite.bb60c0f7.png";